import { CheckboxGroupButtons, FloatingFormItem } from '@/components/_common';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  AverageTicketOptionType,
  ManagerialIncomeFormValues,
  ManagerialIncomeRequestType,
} from '@/core/domain/NetReport/Managerial/Managerial.types';
import { customerPersonTypesLabel } from '@/core/domain/people/Customers/Customers.constants';
import { Col, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<ManagerialIncomeFormValues>;
}

export default function ManagerialInvoicingForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const requestType = Form.useWatch('requestType', form);

  const reportTypeOptions = [
    {
      value: ManagerialIncomeRequestType.actualFiscal,
      label: intl({ id: 'managerialInvoicing.option.realXFiscal' }),
    },
    {
      value: ManagerialIncomeRequestType.actualIncomeTicketAverageTicket,
      label: intl({ id: 'managerialInvoicing.option.realXTicket' }),
    },
    {
      value: ManagerialIncomeRequestType.averageTicketPartsServices,
      label: intl({ id: 'managerialInvoicing.option.avgTicket' }),
    },
    {
      value: ManagerialIncomeRequestType.actualIncomePayablesReceivables,
      label: intl({ id: 'managerialInvoicing.option.realXpayment' }),
    },
  ];

  const averageTicketOptions = [
    {
      value: AverageTicketOptionType.workOrder,
      label: 'Orçamento',
    },
    {
      value: AverageTicketOptionType.sale,
      label: 'Venda direta',
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} maxMonthRange={12} />

      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item
            name="requestType"
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'managerialInvoicing.label.reportType' })}
              </Title>
            }
            initialValue={ManagerialIncomeRequestType.actualFiscal}
            getValueFromEvent={(value) => {
              form.setFieldValue('costCenterIds', undefined);
              form.setFieldValue('averageTicketOption', undefined);
              return value?.target?.value;
            }}
          >
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              size="large"
              options={reportTypeOptions}
            />
          </Form.Item>
        </Col>

        {requestType ===
          ManagerialIncomeRequestType.actualIncomeTicketAverageTicket && (
          <Col span={24}>
            <Form.Item name="customerPersonTypes">
              <CheckboxGroupButtons
                options={Object.entries(customerPersonTypesLabel).map(
                  ([value, label]) => ({ value, label }),
                )}
              />
            </Form.Item>
          </Col>
        )}

        {requestType ===
          ManagerialIncomeRequestType.actualIncomePayablesReceivables && (
          <Col span={24} lg={8}>
            <FloatingFormItem name="costCenterIds" label="Centros de custo">
              <CostCenterInfiniteSelectField
                queryFilter={{ active: true }}
                mode="multiple"
                allowClear
              />
            </FloatingFormItem>
          </Col>
        )}

        {requestType ===
          ManagerialIncomeRequestType.averageTicketPartsServices && (
          <Col span={24}>
            <Form.Item
              name="averageTicketOption"
              label={
                <Title level={5} style={{ margin: '0' }}>
                  Venda direta e orçamentos
                </Title>
              }
              initialValue={[
                AverageTicketOptionType.workOrder,
                AverageTicketOptionType.sale,
              ]}
            >
              <CheckboxGroupButtons options={averageTicketOptions} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
}
